import { Stack, Tooltip, Typography, TypographyProps } from '@mui/material';
import { QuestionIcon } from '@shared/custom-icons';
import { ElementType, ReactNode } from 'react';

export interface FilterLabelProps {
  children: ReactNode;
  component?: ElementType;
  htmlFor?: string;
  id?: string;
  variant?: TypographyProps['variant'];
  description?: string;
  action?: ReactNode;
}

export function FilterLabel({
  children,
  htmlFor,
  component = htmlFor ? 'label' : 'span',
  id,
  variant = 'subtitle2',
  description,
  action,
}: FilterLabelProps) {
  const label = (
    <Typography
      {...({ component, htmlFor, id } as TypographyProps)}
      variant={variant}
      color="text.secondary"
      sx={{ width: 'fit-content', maxWidth: '100%' }}
    >
      {children}
    </Typography>
  );

  if (!description && !action) return label;

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      justifyContent={action ? 'space-between' : 'flex-start'}
      gap={1}
    >
      <Stack flexDirection="row" alignItems="center" gap={1}>
        {label}
        {description && (
          <Tooltip title={description}>
            <QuestionIcon
              sx={{ width: 20, height: 20, color: 'text.secondary' }}
              aria-label={description}
            />
          </Tooltip>
        )}
      </Stack>
      {action}
    </Stack>
  );
}
